import clsx from 'clsx';

import { Box, Drawer, IconButton, Link, List, Toolbar, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';

import { useAdminDrawerStyles } from '../styles';

const DrawerLink = withStyles(Link, theme => ({
  root: {
    color: theme.palette.text.secondary,
    display: 'block',
    '&:hover': {
      color: theme.palette.text.secondary
    },
    '&:visited': {
      color: theme.palette.text.secondary
    }
  }
}));

export type AdminDrawerProps = {
  open: boolean;
  width: number;
  setOpen: (open: boolean) => void;
  higherEdPlan?: string;
};

export const AdminDrawer: React.FC<AdminDrawerProps> = ({
  open,
  width,
  setOpen,
  children,
  higherEdPlan
}) => {
  const l10n = useL10n();
  const { classes } = useAdminDrawerStyles({ width });

  return (
    <Drawer
      anchor="left"
      variant="permanent"
      open={open}
      onClose={() => setOpen(false)}
      className={clsx(classes.drawer, open ? classes.drawerOpen : classes.drawerClosed)}
      classes={{
        paper: open ? classes.drawerOpen : classes.drawerClosed
      }}
    >
      <Toolbar />
      <IconButton
        onClick={() => setOpen(!open)}
        className={clsx(
          classes.toggleButton,
          open ? classes.toggleOpen : classes.toggleClosed
        )}
        disableRipple
        disableFocusRipple
      >
        {open ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <Box className={clsx(classes.content, { [classes.hide]: !open })}>
        <Box className={classes.menu}>
          <List component="nav">
            {children}
          </List>
        </Box>
        <Box className={classes.footer}>
          {higherEdPlan && <Typography variant="h3" color="primary" className={classes.plan}>{higherEdPlan}</Typography>}
          <Box className={classes.footerLinkBox}>
            <DrawerLink
              href={l10n.general.termsUrl}
              rel="noreferrer"
              target="_blank"
              underline="none"
              variant="subtitle2"
            >
              Terms of Service
            </DrawerLink>
            <DrawerLink
              href={l10n.general.privacyUrl}
              rel="noreferrer"
              target="_blank"
              underline="none"
              variant="subtitle2"
            >
              Privacy Policy
            </DrawerLink>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};
